/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var inputDefaultProps = {
  align: "left",
  allowInputOverMax: false,
  autoWidth: false,
  autocomplete: void 0,
  autofocus: false,
  clearable: false,
  placeholder: void 0,
  readonly: false,
  showClearIconOnEmpty: false,
  showLimitNumber: false,
  size: "medium",
  status: void 0,
  type: "text",
  defaultValue: ""
};

export { inputDefaultProps };
//# sourceMappingURL=defaultProps.js.map
